module.exports = __webpack_public_path__ + "media/images/twitter-i-08ce0f10600ae3553b6789e6687ed2ec.png";